import { createAction, props } from '@ngrx/store';
import { MgError } from 'src/app/models/error.model';
import {
  ServiceOptionsRequest,
  ServiceOptionsResponse,
} from './service-options.model';

export enum ServiceOptionsActions {
  getServiceOptions = '[ServiceOption] getServiceOptions',
  getServiceOptionsSuccess = '[ServiceOption] getServiceOptionsSuccess',
  getServiceOptionsFailed = '[ServiceOption] getServiceOptionsFailed',
  updateWithdrawCountry = '[ServiceOption] updateWithdrawCountry',
  fetchServiceOptions = '[ServiceOption] fetchServiceOptions',
  clearServiceOptions = '[ServiceOption] clearServiceOptions',
}

export const GetServiceOptions = createAction(
  ServiceOptionsActions.getServiceOptions,
  props<{ getOptionsRequest: ServiceOptionsRequest }>()
);

export const FetchServiceOptions = createAction(
  ServiceOptionsActions.fetchServiceOptions,
  props<{ getOptionsRequest: ServiceOptionsRequest; endpoint: string }>()
);

export const GetServiceOptionsSuccess = createAction(
  ServiceOptionsActions.getServiceOptionsSuccess,
  props<{ serviceOptionsResponse: ServiceOptionsResponse; endpoint: string }>()
);

export const UpdateWithdrawCountry = createAction(
  ServiceOptionsActions.updateWithdrawCountry,
  props<{ withdrawCountry: string }>()
);

export const GetServiceOptionsFailed = createAction(
  ServiceOptionsActions.getServiceOptionsFailed,
  props<{ error: MgError }>()
);

export const ClearServiceOptions = createAction(
  ServiceOptionsActions.clearServiceOptions
);
